import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Mail, LockKeyhole } from "lucide-react";
import useDocumentTitle from '../../hooks/useDocumentTitle'


export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const targetPath = location.state?.from?.pathname || '/';
      navigate(targetPath, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login({ email, password });
      if (result.success === false) {
        // Handle API returned error (even with 200 status)
        setError(result.error.message || 'Login failed');
        return;
      }

      // Login successful
      // const { from } = location.state || { from: { pathname: '/profile' } };
      // history.replace(from);

      const targetPath = location.state?.from?.pathname || '/';
      navigate(targetPath, { replace: true });
    } catch (err) {
      // Handle thrown errors
      if (err.httpStatus === 401) {
        setError(err.message || 'Invalid email or password');
      } else {
        setError(err.message || 'An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  useDocumentTitle('Login To Admin');
  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="flex justify-center items-center min-h-screen bg-gray-100">

        <div className="bg-white max-w-sm w-full rounded-lg shadow-lg overflow-hidden">
          {/* Close Button */}


          {/* Image Section */}
          <div className="bg-orange-50 text-center p-6">
            <img src="/logo.png" alt="Discount" className="mx-auto h-20" />
            <p className="text-orange-500 font-semibold mt-2">Admin Panel</p>
            {/* <p className="text-gray-500 text-sm">Earn up to 25% with CTLOGIN</p> */}
          </div>

          {error && (
            <div style={{
              color: 'red',
              backgroundColor: '#ffebee',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '15px'
            }}>
              {error}
            </div>
          )}
          {/* Form Section */}
          <form onSubmit={handleSubmit}>
            <div className="p-6">
              <h2 className="text-lg font-semibold">Let's get started</h2>

              <div className="mt-4 flex items-center border rounded-lg overflow-hidden">
                <Mail className="p-1 outline-none" />
                <input
                  type="email"
                  placeholder="Enter email id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="p-2 flex-1 outline-none"
                />
              </div>
              <div className="mt-2 flex items-center border rounded-lg overflow-hidden">
                <LockKeyhole className="p-1 outline-none" />
                <input
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="p-2 flex-1 outline-none"
                />
              </div>
              <button className='w-full mt-4 bg-black text-white py-2 rounded-lg font-semibold' type="submit" disabled={loading} style={{ padding: '10px 15px' }}>
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </div>
          </form>
        </div>

      </div>

      {/* Bottom Navigation */}

    </div>
  );
}
